//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "@/mixins/global";
import chartOTP from "../../components/chartOTPDocument";
import axios, { CancelToken } from "axios";

export default {
  components: {
    chartOTP
  },
  data() {
    return {
     ps: "202001",
      pe: "202053",
      chartDoc: [],
      team1D: [],
      team2D: [],
      team3D: [],

      chartSample: [],
      team1S: [],
      team2S: [],
      team3S: [],

      api: `${this.$apiFix}`
    };
  },
  async mounted() {
    let a = await this.defaultPeriod();
    this.loadData();
  },
  methods: {
      defaultPeriod() {
      let params = new FormData();
      const obj = axios({
        method: "post",
        url: this.$api + "otpmaster.php/otperiod",
        data: params
      }).then(res => {
        this.ps = res.data.ps;
        this.pe = res.data.pe;
      });

      return obj;
    },
    loadData() {
      axios
        .get(
          `${this.api}otp_nonnike.php/gw_doc?ps=${this.ps}&pe=${this.pe}&team=`
        )
        .then(response => {
          this.chartDoc = response.data;
        });
      axios
        .get(
          `${this.api}otp_nonnike.php/gw_doc?ps=${this.ps}&pe=${this.pe}&team=TVN1-1`
        )
        .then(response => {
          this.team1D = response.data;
        });
      axios
        .get(
          `${this.api}otp_nonnike.php/gw_doc?ps=${this.ps}&pe=${this.pe}&team=TVN1-2`
        )
        .then(response => {
          this.team2D = response.data;
        });
      axios
        .get(
          `${this.api}otp_nonnike.php/gw_doc?ps=${this.ps}&pe=${this.pe}&team=TVN2-1`
        )
        .then(response => {
          this.team3D = response.data;
        });

      axios
        .get(
          `${this.api}otp_nonnike.php/gw_sample?ps=${this.ps}&pe=${this.pe}&team=`
        )
        .then(response => {
          this.chartSample = response.data;
        });

      axios
        .get(
          `${this.api}otp_nonnike.php/gw_sample?ps=${this.ps}&pe=${this.pe}&team=TVN1-1`
        )
        .then(response => {
          this.team1S = response.data;
        });
      axios
        .get(
          `${this.api}otp_nonnike.php/gw_sample?ps=${this.ps}&pe=${this.pe}&team=TVN1-2`
        )
        .then(response => {
          this.team2S = response.data;
        });
      axios
        .get(
          `${this.api}otp_nonnike.php/gw_sample?ps=${this.ps}&pe=${this.pe}&team=TVN2-1`
        )
        .then(response => {
          this.team3S = response.data;
        });
    },
    goPage(routerName) {
      this.$router.push({
        name: routerName
      });
    }
  }
};
